import Swiper, {
  Navigation,
  Pagination,
  FreeMode,
  Thumbs,
  Autoplay,
  EffectFade,
} from 'swiper';

class CloserLookFeatures extends HTMLElement {
  constructor() {
    super();

    this.swiper = null;
  }

  connectedCallback() {
    if(this.dataset.load === 'true') {
      this.init();
    }
  }

  init() {
    this.swiper = new Swiper(this.querySelector('.swiper'), {
      // loop: true,
      rewind: true,
      slidesPerView: 1,
      modules: [Navigation],
      navigation: {
        nextEl: this.querySelector('[data-next]'),
        prevEl: this.querySelector('[data-prev]')
      },
    });

    this.swiper.on('slideChange', (swiper) => {
      const closerLook = this.closest('closer-look');
      const activeSlide = closerLook.querySelector('.closer-look__views-images .swiper-slide-active');
      activeSlide.querySelector('.active[data-feature-target]').classList.remove('active');
      activeSlide.querySelector(`[data-feature-target="${swiper.realIndex + 1}"]`).classList.add('active')
    });
  }

  destroy() {
    if(this.swiper) {
      this.swiper.destroy(true, true);
    }
  }
}

customElements.define('closer-look-features', CloserLookFeatures);